import React from 'react';
import ContentfulImage from '@moxy/react-contentful-image';
import HighlightHeader, { HighlightHeaderType } from 'client/components/highlightHeader';
import { Tracking } from 'web-core/src/tracking';
import { ContentfulImageSetType } from 'types/globals/contentful';
import useSearchParams from 'client/hooks/useSearchParams';

import RightArrow from './rightArrow';

export type taxesSectionCta = {
  text: string;
  url: string;
  trackingEvent: string;
};

type Props = {
  header: HighlightHeaderType;
  subHeader: string;
  items: ContentfulImageSetType[];
  cta: taxesSectionCta;
};

const SaveOnTaxesSection = ({ header, items, subHeader, cta }: Props) => {
  const [highlightImage, ...restItems] = items;

  const searchParams = useSearchParams();

  return (
    <section className="save-on-taxes-section">
      <div className="row row-flex">
        <div className="column large-7 pad-x-2 pad-x-small-only content-column">
          <h2 className="margin-bottom-2">
            <HighlightHeader {...header} />
          </h2>
          <h4 className="bold margin-bottom-2 max-w-538px text-xl">{subHeader}</h4>
          <ul className="no-pad no-margin">
            {restItems?.map(({ name, main: { file, title }, key }) => (
              <li key={key}>{`✔️ ${name}`}</li>
            ))}
          </ul>
          <a
            onClick={() =>
              Tracking.track(cta.trackingEvent, {
                cta: cta.text,
              })
            }
            className="inline-block semi-bold margin-top-2"
            href={`${cta.url}${searchParams}`}>
            {cta.text} <RightArrow className="right-arrow-icon" />
          </a>
        </div>
        <div className="column text-center large-5 pad-x-2 pad-x-small-only image-column center-sm-only">
          <picture>
            <source
              media="(max-width: 639px)"
              sizes="(max-width: 639px) 100vw, 639px"
              srcSet={`${highlightImage?.mobile?.file.url} 640w, ${highlightImage?.mobile?.file.url} 1200w`} />
            <img
              sizes="(max-width: 3003px) 50vw, 600px"
              srcSet={`${highlightImage.main.file.url} 640w, ${highlightImage.main.file.url} 1200w`}
              src={highlightImage.main.file.url}
              className="image-section"
              alt="Mobile Phone" />
          </picture>
        </div>
      </div>
    </section>
  );
};

export default SaveOnTaxesSection;
